module.exports = __webpack_public_path__ + "73cc51ad07737abb3e0f000956feb9c8.MP3";